export const TRANSACTION_TYPE_CHOICES: Map<number, string> = new Map([
  [2, "Prestación de servicios"],
  [1, "Venta de mercadería"],
  [3, "Mixto (Venta de mercadería y servicios)"],
  [4, "Venta de activo fijo"],
]);
